const initToolpediaSkinFiles = (scope = document) => {
  scope.querySelectorAll('[data-toolpedia-skin-files]').forEach((root) => {
    if (root.dataset.toolpediaSkinFilesInit === 'true') {
      return;
    }

    root.dataset.toolpediaSkinFilesInit = 'true';

    const items = Array.from(root.querySelectorAll('[data-blog-article]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-blog-tag]'));
    const emptyState = root.querySelector('[data-blog-empty]');
    const pagination = root.querySelector('[data-blog-pagination]');
    const prevIconTemplate = root.querySelector('[data-pagination-prev-icon]');
    const nextIconTemplate = root.querySelector('[data-pagination-next-icon]');
    const pageSize = Math.max(parseInt(root.dataset.blogPostLimit || '8', 10) || 8, 1);

    let activeTag = '';
    let currentPage = 1;

    const getFilteredItems = () => items.filter((item) => {
      const tags = (item.dataset.blogTags || '').split('|').filter(Boolean);
      return !activeTag || tags.includes(activeTag);
    });

    const setFilterButtonsState = () => {
      filterButtons.forEach((button) => {
        const isActive = (button.dataset.blogTag || '') === activeTag;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const createPageButton = (label, className, disabled, onClick, ariaLabel) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.disabled = !!disabled;
      button.textContent = label;
      if (ariaLabel) {
        button.setAttribute('aria-label', ariaLabel);
      }
      button.addEventListener('click', onClick);
      return button;
    };

    const createArrow = (direction) => {
      const template = direction === 'prev' ? prevIconTemplate : nextIconTemplate;
      if (!template) {
        const arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = direction === 'prev' ? '\u2190' : '\u2192';
        return arrow;
      }

      const fragment = template.content.cloneNode(true);
      const node = fragment.firstElementChild || fragment.firstChild;
      if (node && node.nodeType === Node.ELEMENT_NODE) {
        node.setAttribute('aria-hidden', 'true');
      }
      return fragment;
    };

    const renderPagination = (pageCount) => {
      if (!pagination) {
        return;
      }

      pagination.innerHTML = '';

      if (pageCount <= 1) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      const pageNumbers = document.createElement('div');
      pageNumbers.className = 'page-numbers nav-links';

      const prevButton = createPageButton('', 'prev', currentPage === 1, () => {
        if (currentPage > 1) {
          currentPage -= 1;
          update();
        }
      }, 'Previous page');
      prevButton.appendChild(createArrow('prev'));
      pageNumbers.appendChild(prevButton);

      for (let page = 1; page <= pageCount; page += 1) {
        const pageButton = createPageButton(String(page), 'page', false, () => {
          currentPage = page;
          update();
        });

        if (page === currentPage) {
          pageButton.classList.add('current', 'active');
          pageButton.setAttribute('aria-current', 'page');
        }

        pageNumbers.appendChild(pageButton);
      }

      const nextButton = createPageButton('', 'next', currentPage === pageCount, () => {
        if (currentPage < pageCount) {
          currentPage += 1;
          update();
        }
      }, 'Next page');
      nextButton.appendChild(createArrow('next'));
      pageNumbers.appendChild(nextButton);

      pagination.appendChild(pageNumbers);
    };

    const update = () => {
      const filteredItems = getFilteredItems();
      const pageCount = Math.max(1, Math.ceil(filteredItems.length / pageSize));

      currentPage = Math.min(Math.max(currentPage, 1), pageCount);

      items.forEach((item) => {
        item.hidden = true;
      });

      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;

      filteredItems.forEach((item, index) => {
        item.hidden = index < start || index >= end;
      });

      if (emptyState) {
        emptyState.hidden = filteredItems.length !== 0;
      }

      setFilterButtonsState();
      renderPagination(pageCount);
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeTag = button.dataset.blogTag || '';
        currentPage = 1;
        update();
      });
    });

    update();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initToolpediaSkinFiles());
} else {
  initToolpediaSkinFiles();
}

document.addEventListener('shopify:section:load', (event) => {
  initToolpediaSkinFiles(event.target);
});
